import { memo } from 'react';
import { Button, IconButton } from './SendButton.styles';

export interface SendButtonProps {
  title: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit';
  isEmbedded?: boolean;
}

export const SendButton = memo<SendButtonProps>((props) => {
  const { onClick, title, disabled, type, isEmbedded } = props;

  return (
    <Button
      isEmbedded={isEmbedded}
      onClick={() => onClick?.()}
      title={title}
      disabled={disabled}
      role="button"
      aria-label="send button"
      data-testid="saywhatt-chat-send-button"
      type={type || 'button'}
    >
      <IconButton />
    </Button>
  );
});

SendButton.displayName = 'SendButton';
